import React from 'react';
import { IconProps } from '../Icons.interface';

export const FilterIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.625 8.5C3.19402 8.5 2.7807 8.32879 2.47595 8.02405C2.1712 7.7193 2 7.30598 2 6.875C2 6.44402 2.1712 6.0307 2.47595 5.72595C2.7807 5.42121 3.19402 5.25 3.625 5.25M3.625 8.5C4.05598 8.5 4.4693 8.32879 4.77405 8.02405C5.0788 7.7193 5.25 7.30598 5.25 6.875C5.25 6.44402 5.0788 6.0307 4.77405 5.72595C4.4693 5.42121 4.05598 5.25 3.625 5.25M3.625 8.5V15M3.625 5.25V2M8.5 13.375C8.06902 13.375 7.6557 13.2038 7.35095 12.899C7.04621 12.5943 6.875 12.181 6.875 11.75C6.875 11.319 7.04621 10.9057 7.35095 10.601C7.6557 10.2962 8.06902 10.125 8.5 10.125M8.5 13.375C8.93098 13.375 9.3443 13.2038 9.64905 12.899C9.95379 12.5943 10.125 12.181 10.125 11.75C10.125 11.319 9.95379 10.9057 9.64905 10.601C9.3443 10.2962 8.93098 10.125 8.5 10.125M8.5 13.375V15M8.5 10.125V2M13.375 6.0625C12.944 6.0625 12.5307 5.89129 12.226 5.58655C11.9212 5.2818 11.75 4.86848 11.75 4.4375C11.75 4.00652 11.9212 3.5932 12.226 3.28845C12.5307 2.9837 12.944 2.8125 13.375 2.8125M13.375 6.0625C13.806 6.0625 14.2193 5.89129 14.524 5.58655C14.8288 5.2818 15 4.86848 15 4.4375C15 4.00652 14.8288 3.5932 14.524 3.28845C14.2193 2.9837 13.806 2.8125 13.375 2.8125M13.375 6.0625V15M13.375 2.8125V2"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
